module.exports = __webpack_public_path__ + "media/img/about/person/suren-d89a6974f21b8117bec258414b549363.png";